//# sourceMappingURL=text.mjs.map
/// <reference types="./text.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $image from "../../data/docx/image.mjs";
import * as $page_break from "../../data/docx/page_break.mjs";
import * as $decrypt from "../../decrypt.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

export class Text extends $CustomType {
  constructor(text, style) {
    super();
    this.text = text;
    this.style = style;
  }
}
export const Text$Text = (text, style) => new Text(text, style);
export const Text$isText = (value) => value instanceof Text;
export const Text$Text$text = (value) => value.text;
export const Text$Text$0 = (value) => value.text;
export const Text$Text$style = (value) => value.style;
export const Text$Text$1 = (value) => value.style;

export class RunText extends $CustomType {
  constructor(content) {
    super();
    this.content = content;
  }
}
export const RunContent$RunText = (content) => new RunText(content);
export const RunContent$isRunText = (value) => value instanceof RunText;
export const RunContent$RunText$content = (value) => value.content;
export const RunContent$RunText$0 = (value) => value.content;

export class RunTab extends $CustomType {}
export const RunContent$RunTab = () => new RunTab();
export const RunContent$isRunTab = (value) => value instanceof RunTab;

export class RunBreak extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const RunContent$RunBreak = ($0) => new RunBreak($0);
export const RunContent$isRunBreak = (value) => value instanceof RunBreak;
export const RunContent$RunBreak$0 = (value) => value[0];

export class RunImage extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const RunContent$RunImage = ($0) => new RunImage($0);
export const RunContent$isRunImage = (value) => value instanceof RunImage;
export const RunContent$RunImage$0 = (value) => value[0];

export class Run extends $CustomType {
  constructor(children, style) {
    super();
    this.children = children;
    this.style = style;
  }
}
export const Run$Run = (children, style) => new Run(children, style);
export const Run$isRun = (value) => value instanceof Run;
export const Run$Run$children = (value) => value.children;
export const Run$Run$0 = (value) => value.children;
export const Run$Run$style = (value) => value.style;
export const Run$Run$1 = (value) => value.style;

export function decoder() {
  return $decrypt.optional_field(
    "text",
    $decode.string,
    (text) => {
      let text$1 = $option.unwrap(text, "");
      return $decrypt.optional_field(
        "style",
        (() => {
          let _pipe = $decode.dict($decode.string, $decode.string);
          return $decode.map(_pipe, $dict.to_list);
        })(),
        (style) => {
          let style$1 = $option.unwrap(style, toList([]));
          return $decode.success(new Text(text$1, style$1));
        },
      );
    },
  );
}

export function to_html(text) {
  return $bool.guard(
    $list.is_empty(text.style),
    $h.text(text.text),
    () => {
      let styles = $list.map(
        text.style,
        (s) => { return $a.style(toList([[s[0], s[1]]])); },
      );
      return $h.span(styles, toList([$h.text(text.text)]));
    },
  );
}

export function encode(text) {
  return $json.object(
    toList([
      ["text", $json.string(text.text)],
      [
        "style",
        (() => {
          let _pipe = text.style;
          let _pipe$1 = $list.map(
            _pipe,
            (_capture) => { return $pair.map_second(_capture, $json.string); },
          );
          return $json.object(_pipe$1);
        })(),
      ],
    ]),
  );
}

export function run_content_decoder() {
  return $decode.field(
    "type",
    $decode.string,
    (type_) => {
      if (type_ === "text") {
        return $decode.field(
          "content",
          $decode.string,
          (content) => { return $decode.success(new RunText(content)); },
        );
      } else if (type_ === "tab") {
        return $decode.success(new RunTab());
      } else if (type_ === "break") {
        return $decode.then$(
          $page_break.decoder(),
          (break_elem) => { return $decode.success(new RunBreak(break_elem)); },
        );
      } else if (type_ === "image") {
        return $decode.then$(
          $image.decoder(),
          (img) => { return $decode.success(new RunImage(img)); },
        );
      } else {
        return $decode.failure(new RunTab(), "run_content");
      }
    },
  );
}

export function encode_run_content(content) {
  if (content instanceof RunText) {
    let text = content.content;
    return $json.object(
      toList([["type", $json.string("text")], ["content", $json.string(text)]]),
    );
  } else if (content instanceof RunTab) {
    return $json.object(toList([["type", $json.string("tab")]]));
  } else if (content instanceof RunBreak) {
    let break_elem = content[0];
    return $page_break.encode(break_elem);
  } else {
    let img = content[0];
    return $image.encode(img);
  }
}

export function run_decoder() {
  return $decode.field(
    "children",
    $decode.list(run_content_decoder()),
    (children) => {
      return $decode.field(
        "style",
        (() => {
          let _pipe = $decode.dict($decode.string, $decode.string);
          let _pipe$1 = $decode.map(_pipe, $dict.to_list);
          return $decode.optional(_pipe$1);
        })(),
        (style) => { return $decode.success(new Run(children, style)); },
      );
    },
  );
}

export function encode_run(run) {
  return $json.object(
    toList([
      ["type", $json.string("run")],
      ["children", $json.array(run.children, encode_run_content)],
      [
        "style",
        $json.nullable(
          run.style,
          (styles) => {
            let _pipe = styles;
            let _pipe$1 = $list.map(
              _pipe,
              (_capture) => { return $pair.map_second(_capture, $json.string); },
            );
            return $json.object(_pipe$1);
          },
        ),
      ],
    ]),
  );
}

export function run_content_to_html(content) {
  if (content instanceof RunText) {
    let text = content.content;
    return $h.text(text);
  } else if (content instanceof RunTab) {
    return $h.text("\t");
  } else if (content instanceof RunBreak) {
    let break_elem = content[0];
    let $ = break_elem.break_type;
    if ($ instanceof $page_break.Line) {
      return $h.br(toList([]));
    } else {
      return $page_break.to_html(break_elem);
    }
  } else {
    let img = content[0];
    return $image.to_html(img);
  }
}

export function run_to_html(run) {
  let children_html = $list.map(
    run.children,
    (child) => { return run_content_to_html(child); },
  );
  let $ = run.style;
  if ($ instanceof Some) {
    let styles = $[0];
    let style_attr = $a.style(styles);
    return $h.span(toList([style_attr]), children_html);
  } else {
    return $h.span(toList([]), children_html);
  }
}
